import { calcularLiquidacionChile } from "./empleados";

// liquidoBonoSplit — parte el líquido Chile de un mes en su porción SIN bono y la contribución NETA
// del bono, corriendo el motor DOS veces (mismo patrón que `bonoNeto` de FlujoCajaV2, commit 46adc2bb
// — NO se reimplementa la fórmula, 10.1).
//
//   liquidoConBono  = líquido total (base + grati + bonos_fijo/variable + haberes imponibles)
//   liquidoSinBono  = líquido con el bono en 0
//   bonoNeto        = liquidoConBono − liquidoSinBono  (contribución neta del bono, ≥ 0)
//
// DOS DEFINICIONES de "bono", por el 5º parámetro `incluirHaberesBono` (default false):
//   • false (DEFAULT) → toggle SOLO `bonos_fijo`/`bonos_variable` (el bono de VIGENCIA). Los haberes
//     tipo bono/otro quedan en ambas corridas (no se separan). Lo usa el CANDADO de VincularMovimiento
//     (decisión Ignacio 2026-08-29: un bono variable/one-off NO se valida).
//   • true → además saca los haberes `tipo` bono/otro en la corrida "sin bono" → `bonoNeto` incluye
//     TODO bono (vigencia + haber discrecional). Es la definición CONTABLEMENTE CORRECTA para el
//     desglose de pendientes / `rrhhEntries`: un haber-bono ES un bono (va a la línea Bono y se paga
//     como `tipo='bono'`); si quedara en el sueldo se mis-tiparía el pago. Requiere que `haberesMes`
//     traiga `tipo`. Es la MISMA definición que ya usa `rrhhEntries` (FlujoCajaV2) hoy → cuando la
//     Fase 3 lo consuma, los números no cambian. Ambas definiciones COINCIDEN si no hay haber-bono
//     (caso Franco).
//
// @param {Object} rem  remuneración vigente del mes.
// @param {number} ufDelMes / utmDelMes  UF (último día) y UTM del mes.
// @param {Array<{monto, imponible, tipo}>} haberesMes  haberes imponibles del mes.
// @param {boolean} incluirHaberesBono  ver arriba.
export const liquidoBonoSplit = (rem, ufDelMes, utmDelMes, haberesMes = [], incluirHaberesBono = false) => {
  if (!rem) return { liquidoConBono: 0, liquidoSinBono: 0, bonoNeto: 0 };
  const liquidoConBono = calcularLiquidacionChile(rem, ufDelMes, 0, utmDelMes, haberesMes).liquido;
  const remSinBono = { ...rem, bonos_fijo: 0, bonos_variable: 0 };
  const haberesSinBono = incluirHaberesBono
    ? (haberesMes || []).filter((h) => h.tipo !== "bono" && h.tipo !== "otro")
    : haberesMes;
  const liquidoSinBono = calcularLiquidacionChile(remSinBono, ufDelMes, 0, utmDelMes, haberesSinBono).liquido;
  return { liquidoConBono, liquidoSinBono, bonoNeto: Math.max(0, liquidoConBono - liquidoSinBono) };
};
